import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { User } from '../models/user';
import { CommonHandler } from 'src/app/shared/handlers/common-handler';
import { AccessHandler } from '../handlers/access-handler';
import { StorageHandler } from 'src/app/shared/handlers/storage-handler';
import { ReplaySubject } from 'rxjs';
import { NavParam } from 'src/app/shared/interfaces/global-filter-model';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  readonly ACCESS_USER: string = 'mondelez_user';
  readonly ACCESS_PARAMS: string = 'mondelez_access_params';
  expiredCounter: number = 0.0;
  private _user: any;
  private _token: any;
  private _globalParams: any;
  private _navList: NavParam[] = [];

  constructor(private titleService: Title, private accessHandler: AccessHandler, private router: Router) {}

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  createUserSession(user: User, token: any, expiresOn: any, globalParams: any): void {
    this.expiredCounter = 0;
    this._user = CommonHandler.getCopy(user);
    this._token = CommonHandler.getCopy(token);
    this._globalParams = CommonHandler.getCopy(globalParams);
    const cookie = { token, globalParams };
    const accessCookie = { user };
    this.accessHandler.createAccessItem(this.ACCESS_PARAMS, JSON.stringify(cookie), expiresOn);
    this.accessHandler.createAccessItem(this.ACCESS_USER, JSON.stringify(accessCookie), expiresOn);
    // this._navList.length = 0;
    this._navList = user.user_screens;
  }

  deleteUserSession(): void {
    this.accessHandler.deleteAccessItem(this.ACCESS_PARAMS);
    this.accessHandler.deleteAccessItem(this.ACCESS_USER);
    this._user = null;
    this._token = null;
    this._navList = [];
    StorageHandler.clearStorages();
  }

  get user(): User {
    if (!this._user) {
      const userItem = this.accessHandler.readAccessItem(this.ACCESS_USER);
      if (userItem) {
        this._user = JSON.parse(userItem).user;
        this._navList = this._user.user_screens;
      } else {
        this._user = null;
        this._navList = [];
      }
    }
    return this._user;
  }

  get token(): string {
    if (!this._token) {
      const paramsItem = this.accessHandler.readAccessItem(this.ACCESS_PARAMS);
      if (paramsItem) {
        this._token = JSON.parse(paramsItem).token;
      } else {
        this._token = null;
      }
    }
    return this._token;
  }

  get globalParams(): any {
    if (!this._globalParams) {
      const paramsItem = this.accessHandler.readAccessItem(this.ACCESS_PARAMS);
      if (paramsItem) {
        this._globalParams = JSON.parse(paramsItem).globalParams;
      } else {
        this._globalParams = null;
      }
    }
    return this._globalParams;
  }

  public get authenticated(): boolean {
    return this.user != null && this.token != null;
  }

  public create_UUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

  // public updateUserScreenMapping(value: NavParam[]) {
  //   this._navList = value;
  // }

  getNavList(): any {
    if (this._navList.length == 0) {
      const userItem = this.accessHandler.readAccessItem(this.ACCESS_USER);
      if (userItem) {
        this._navList = JSON.parse(userItem).user?.user_screens;
      } else {
        this._navList = [];
      }
    }
    return this._navList;
  }

  public permittedScreen(currentUrl: string, parentScreen?: string) {
    let url: string;
    if (this.getNavList().length === 0) {
      return url;
    }

    if (parentScreen) {
      let currentNav =
        this._navList.find(
          (el) => el.screen_name === parentScreen && el.is_active && currentUrl === '/app/' + el.screen_name + '/' + (el['h1'] ? el.h1 + '/' : '') + el.supply_mode
        ) || this._navList.find((el) => el.screen_name === parentScreen && el.is_active);
      if (currentNav) {
        url = '/app/' + currentNav.screen_name + '/' + (currentNav['h1'] ? currentNav.h1 + '/' : '') + currentNav.supply_mode;
      }
    } else {
      // return either current enable route url or first route url
      let currentNav =
        this._navList.find((el) => el.is_active && currentUrl === '/app/' + el.screen_name + '/' + (el['h1'] ? el.h1 + '/' : '') + el.supply_mode) ||
        this._navList.find((el) => el.is_active);
      if (currentNav) {
        url = '/app/' + currentNav.screen_name + '/' + (currentNav['h1'] ? currentNav.h1 + '/' : '') + currentNav.supply_mode;
      }
    }
    return url;
  }

  redirectMsalLogin() {
    this.router.navigate(['auth/msal-login']);
    const uuid = this.create_UUID();
    StorageHandler.setLocalStorage('state', uuid);
    const redirectUrl = `https://login.microsoftonline.com/${environment.msalTenant}/oauth2/v2.0/authorize?
                client_id=${environment.msalClient}
                &response_type=code
                &redirect_uri=${environment.msalRedirectUrl}
                &response_mode=query
                &scope=openid%20offline_access%20user.read
                &state=${uuid}`;
    setTimeout(function () {
      location.replace(redirectUrl);
    }, 0);
  }
}
